import Vue from 'vue';
import router from '@/router';
import * as Sentry from '@sentry/vue';
import { markSentryEnabled } from '@/utils/sentry';

const dsn = process.env.VUE_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    Vue,
    dsn,
    environment:
      process.env.VUE_APP_SENTRY_ENVIRONMENT ||
      process.env.NODE_ENV ||
      'development',
    release: process.env.VUE_APP_SENTRY_RELEASE || undefined,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      /Object captured as promise rejection with keys: fieldErrors/i,
      /^cancelled$/i,
      'AbortError',
      /reading 'mutations'/i,
      /Failed to execute 'setEnd' on 'Range'/i,
      /^TypeError: Failed to fetch/i,
      /Redirected when going from/i,
      /Request failed with status code 502/i,
    ],
  });
  markSentryEnabled();
}
